<div class="dialog-form">
    <div id='signature-div'></div>
</div>